import { Navigate } from "react-router-dom"
import { useAuth } from "../store"

export interface ProtectedRouteProps {
  redirect: string
  isAuth?: boolean
  children: React.ReactNode
}

export default function ProtectedRoute({
  redirect,
  isAuth = false,
  children,
}: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth()

  // Redirect either if route needs auth and user is not authenticated, and vice versa
  if (isAuth !== isAuthenticated) {
    return <Navigate to={redirect} replace />
  }

  return <>{children}</>
}
